exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cascader[data-v-268be5b7] {\n  display: inline-block;\n}\n.cascader[data-v-268be5b7] .ivu-cascader .ivu-input {\n  background: #ffffff !important;\n  color: #595959 !important;\n}\n", ""]);

// exports
